import React from "react";
import Modal from "../modal/Modal";
import { QrCode, Download, LucideX } from "lucide-react";
import QRCode from "react-qr-code";

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  qrCodeData: any;
  onDownloadPNG: () => void;
  onDownloadSVG: () => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({
  isOpen,
  onClose,
  qrCodeData,
  onDownloadPNG,
  onDownloadSVG,
}) => {
  if (!qrCodeData) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalClass="bg-white w-full max-w-6xl max-h-[90vh] rounded-xl shadow-lg flex flex-col"
      closeButton={false}
    >
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold mb-4 text-center">
            QR Code - {qrCodeData.assetName || qrCodeData.washroomName || qrCodeData.visitorName || "QR Code"}
          </h2>

          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close modal"
          >
            <LucideX size={24} className="text-gray-600" />
          </button>
        </div>
        <div className="flex flex-col items-center">
          {qrCodeData.qrCodeImage ? (
            <img
              src={qrCodeData.qrCodeImage}
              alt="QR Code"
              className="w-64 h-64 border rounded-lg mb-4"
            />
          ) : qrCodeData.qrData ? (
            <div className="w-64 h-64 border rounded-lg mb-4 p-4 bg-white flex items-center justify-center">
              <QRCode
                value={JSON.stringify(qrCodeData.qrData)}
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                viewBox={`0 0 256 256`}
              />
            </div>
          ) : null}

          <div className="text-center mb-4">
            <p className="text-sm text-gray-600 mb-2">
              ID: {qrCodeData.qrData?.assetId || qrCodeData.qrData?.washroomId || qrCodeData.qrData?.visitorId || qrCodeData.qrData?.qrCode}
            </p>
            <p className="text-xs text-gray-500">
              Scan this QR code with the mobile app.
            </p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={onDownloadPNG}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-sm"
            >
              <Download className="w-4 h-4" />
              PNG
            </button>
            <button
              onClick={onDownloadSVG}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors text-sm"
            >
              <Download className="w-4 h-4" />
              SVG
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QRCodeModal;
